
import { find } from "../utils/dom";
import Swiper from "swiper";

const PageFundacaoMariaLuisa = () =>{
	const page = find("[js-page='fundacao-maria-luisa']");
	if(!page) return;


	function SwiperCronogramaMobile(){
		const SwiperInfoCronologiaMobile = new Swiper(".swiper-info-cronologia-mobile",{
			slidesPerView: 1,
			spaceBetween: 0,
			mousewheel: false,
			simulateTouch: false, 
			touchStartPreventDefault: false,
			grabCursor: false,
		})

		console.log(SwiperInfoCronologiaMobile.slides.length)
	
		const SwiperCronologiaMobile = new Swiper(".swiper-cronologia-mobile", {
			slidesPerView: 3,
			spaceBetween: 0,
			centeredSlides: true,
			initialSlide: 2,
			simulateTouch: false, 
			navigation: {
				nextEl: ".swiper-button-next.swiper-button-next-mobile",
				prevEl: ".swiper-button-prev.swiper-button-prev-mobile",
			},
			on:{
				init: (swiper)=>{
					const TotalItemSlide = swiper.slides.length;
					const AtualItemIndex = swiper.activeIndex;
	
					const prevButton = find(".swiper-button-prev.swiper-button-prev-mobile");
					const nextButton = find(".swiper-button-next.swiper-button-next-mobile");
	
	
					if(AtualItemIndex < 1){
						prevButton.classList.add("swiper-button-disabled");
						prevButton.setAttribute("disabled", "true");
					}
					
					if(AtualItemIndex >= (TotalItemSlide - 1)){
						nextButton.classList.add("swiper-button-disabled");
						nextButton.setAttribute("disabled", "true");
					}
	
					SwiperInfoCronologiaMobile.slideTo(AtualItemIndex);
				},
				slideChange: (swiper)=>{
					const TotalItemSlide = swiper.slides.length;
					const AtualIndexItem = swiper.activeIndex;
	
					
					const prevButton = find(".swiper-button-prev.swiper-button-prev-mobile");
					const nextButton = find(".swiper-button-next.swiper-button-next-mobile");
	
	
					if(AtualIndexItem < 1){
						swiper.slideTo(1);
					}
	
					if(AtualIndexItem <= 1){
						prevButton.classList.add("swiper-button-disabled");
						prevButton.setAttribute("disabled", "true");
					}else{
						prevButton.classList.remove("swiper-button-disabled");
						prevButton.setAttribute("disabled", "false");
					}
	
					
					if(AtualIndexItem >= (TotalItemSlide - 1)){
						swiper.slideTo(AtualIndexItem - 1);
	
						
					}
					if(AtualIndexItem >= (TotalItemSlide - 2)){
						nextButton.classList.add("swiper-button-disabled");
						nextButton.setAttribute("disabled", "true");
					}else{
						nextButton.classList.remove("swiper-button-disabled");
						nextButton.setAttribute("disabled", "false");
					}

					
					SwiperInfoCronologiaMobile.slideTo(AtualIndexItem);

			
				}
				
			}
			
		})
	}


	function SwiperCronogramaDesktop(){

		const SwiperInfoCronologia = new Swiper(".swiper-info-cronologia",{
			slidesPerView: 1,
			spaceBetween: 0,
			mousewheel: false,
			simulateTouch: false, 
			touchStartPreventDefault: false,
			grabCursor: false,
		})
	
		const SwiperCronologia = new Swiper(".swiper-cronologia", {
			slidesPerView: 7,
			spaceBetween: 0,
			centeredSlides: true,
			initialSlide: 4,
			
			simulateTouch: false, 
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			on:{
				init: (swiper)=>{
					const TotalItemSlide = swiper.slides.length;
					const ProxIndexItem = swiper.activeIndex;
	
					const prevButton = find(".swiper-button-prev");
					const nextButton = find(".swiper-button-next");
	
					if(ProxIndexItem < 4){
						prevButton.classList.add("swiper-button-disabled");
						prevButton.setAttribute("disabled", "true");
					}
					
					if(ProxIndexItem >= (TotalItemSlide - 4)){
						nextButton.classList.add("swiper-button-disabled");
						nextButton.setAttribute("disabled", "true");
					}
	
					SwiperInfoCronologia.slideTo(swiper.activeIndex);
				},
				slideChange:(swiper)=>{
					const TotalItemSlide = swiper.slides.length;
					const ProxIndexItem = swiper.activeIndex;
	
					const prevButton = find(".swiper-button-prev");
					const nextButton = find(".swiper-button-next");
	
					if(ProxIndexItem < 3){
						swiper.slideTo(3);
					}
	
					if(ProxIndexItem <= 3){
						prevButton.classList.add("swiper-button-disabled");
						prevButton.setAttribute("disabled", "true");
					}else{
						prevButton.classList.remove("swiper-button-disabled");
						prevButton.setAttribute("disabled", "false");
						SwiperInfoCronologia.slideTo(ProxIndexItem);
					}
					
	
	
					if(ProxIndexItem >= (TotalItemSlide - 3)){
						swiper.slideTo(ProxIndexItem - 1);
					}
	
					if(ProxIndexItem >= (TotalItemSlide - 4)){
						nextButton.classList.add("swiper-button-disabled");
						nextButton.setAttribute("disabled", "true");
					}else{
						nextButton.classList.remove("swiper-button-disabled");
						nextButton.setAttribute("disabled", "false");
						SwiperInfoCronologia.slideTo(ProxIndexItem);
					}
				}
				
			}
		});
	}


	const mediaQuery = window.matchMedia('(max-width: 768px)');
	if (mediaQuery.matches) {
		SwiperCronogramaMobile();
	}else{
		SwiperCronogramaDesktop();
	}


}

export default PageFundacaoMariaLuisa;